import { createContext } from "react";
import PropTypes from "prop-types";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { isNil } from "lodash";

export const EventsContext = createContext({
  eventsLoading: true,
  eventsError: false,
  events: {},
  refetchEvents: async () => {}
});
EventsContext.displayName = "EventsContext";

export const EventsProvider = ({ children, caseId }) => {
  const {
    loading,
    error,
    response: events,
    refetch: refetchEvents
  } = useFetchGetV2(
    `events?size=9999&ordering=-date_time&case_id__in=${caseId}`,
    isNil(caseId)
  );

  return (
    <EventsContext.Provider value={{ loading, error, events, refetchEvents }}>
      {children}
    </EventsContext.Provider>
  );
};

EventsProvider.propTypes = {
  children: PropTypes.node,
  caseId: PropTypes.number
};
